import { render, staticRenderFns } from "./LocationManager.vue?vue&type=template&id=2be50a10&scoped=true"
import script from "./LocationManager.vue?vue&type=script&lang=js"
export * from "./LocationManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be50a10",
  null
  
)

export default component.exports